import { useAuth0 } from "@auth0/auth0-react";
import { getConnectorVersions } from "api/ConnectorVersions";
import { useEffect, useState } from "react";

export const useConnectorVersions = (connectorId) => {
  const { user } = useAuth0();
  const [connectorVersions, setConnectorVersions] = useState([]);

  const handleFetchConnectorVersions = async () => {
    const versions = await getConnectorVersions(user?.stripeId, connectorId);
    setConnectorVersions(versions);
  };

  const handleAppendVersion = (version) => setConnectorVersions((prev) => prev.concat(version));

  const handleUpdateVersion = (updatedVersion) =>
    setConnectorVersions((prev) =>
      prev.map((version) =>
        version.id === updatedVersion.id
          ? {
              ...version,
              ...updatedVersion,
            }
          : version
      )
    );

  const handleRemoveVersion = (removedVersion) =>
    setConnectorVersions((prev) => prev.filter((version) => version.id !== removedVersion.id));

  useEffect(() => {
    handleFetchConnectorVersions();
  }, []);

  return {
    connectorVersions,
    handleAppendVersion,
    handleRemoveVersion,
    handleUpdateVersion,
    refetchConnectorVersions: handleFetchConnectorVersions,
  };
};
